// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__Ha+Ky","btnsContainer":"Modal_btnsContainer__CFDG0"};